import { render } from "./IdeaCard.vue?vue&type=template&id=1c1af884"
import script from "./IdeaCard.vue?vue&type=script&lang=js"
export * from "./IdeaCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__